import { H5 } from 'UIComponents/elements/headings';
import styled, { css, mediaQuery } from 'academy-common-lib/utils/Styling';
import { getProxyUrl, getPublicLang } from 'academy-common-lib/utils/url';
import UIList from 'UIComponents/list/UIList';
import UITag from 'UIComponents/tag/UITag';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ACContentBreakdownList from 'academy-common-lib/components/list/ACContentBreakdownList';
import { useEffect, useRef, useState } from 'react';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SecondaryDetailsSection = styled.section.withConfig({
  displayName: "PublicLandingPageSecondaryDetails__SecondaryDetailsSection",
  componentId: "sc-1ohw8cs-0"
})(["width:100%;padding:12px 0 12px 0;min-height:400px;", ";"], mediaQuery('mobile', css(["width:100%;"])));
const DynamicWidthSection = ({
  children,
  className,
  embeddedSignupRef
}) => {
  const ref = useRef(null);
  const [isIntersecting, setIsIntersecting] = useState(false);
  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      var _embeddedSignupRef$cu;
      const entry = entries[0];
      const elementTop = entry.target.getBoundingClientRect().top;
      const signupBottom = (embeddedSignupRef === null || embeddedSignupRef === void 0 || (_embeddedSignupRef$cu = embeddedSignupRef.current) === null || _embeddedSignupRef$cu === void 0 ? void 0 : _embeddedSignupRef$cu.getBoundingClientRect().bottom) || 0;
      setIsIntersecting(elementTop < signupBottom);
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [embeddedSignupRef]);
  return /*#__PURE__*/_jsx("div", {
    className: className,
    ref: ref,
    style: {
      width: isIntersecting ? '50%' : '100%',
      paddingRight: isIntersecting ? 24 : 0
    },
    children: children
  });
};
const PublicLandingPageSecondaryDetails = ({
  description,
  personas,
  learnings,
  availableLanguages = [getPublicLang()],
  duration,
  lessonCount,
  quizCount,
  videoCount,
  exerciseCount,
  contentType,
  subCategories,
  embeddedSignupRef
}) => {
  const otherLanguages = availableLanguages.filter(lang => lang !== getPublicLang()).sort();
  const location = useLocation();
  return /*#__PURE__*/_jsxs(SecondaryDetailsSection, {
    children: [personas && !!personas.length && /*#__PURE__*/_jsxs(DynamicWidthSection, {
      embeddedSignupRef: embeddedSignupRef,
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.contentLandingPage.secondaryDetails.personasHeading"
        })
      }), /*#__PURE__*/_jsx(UIList, {
        className: "m-bottom-10 p-left-6",
        styled: true,
        children: personas
      })]
    }), learnings && !!learnings.length && /*#__PURE__*/_jsxs(DynamicWidthSection, {
      embeddedSignupRef: embeddedSignupRef,
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.contentLandingPage.secondaryDetails.learningsHeading"
        })
      }), /*#__PURE__*/_jsx(UIList, {
        className: "m-bottom-10 p-left-6",
        styled: true,
        children: learnings
      })]
    }), otherLanguages && !!otherLanguages.length && /*#__PURE__*/_jsxs(DynamicWidthSection, {
      embeddedSignupRef: embeddedSignupRef,
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.contentLandingPage.secondaryDetails.availableLanguagesHeading"
        })
      }), /*#__PURE__*/_jsx(List, {
        inline: true,
        marginBlockEnd: "1000",
        children: otherLanguages.map(lang => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(UITag, {
            href: getProxyUrl(location.pathname, lang),
            children: LanguageNames[lang]
          }, lang)
        }, lang))
      })]
    }), /*#__PURE__*/_jsxs(DynamicWidthSection, {
      className: "m-bottom-10",
      embeddedSignupRef: embeddedSignupRef,
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.contentLandingPage.secondaryDetails.includesHeading"
        })
      }), /*#__PURE__*/_jsx(ACContentBreakdownList, {
        certificateCount: contentType === 'CERTIFICATION' ? 1 : 0,
        duration: duration,
        exerciseCount: exerciseCount,
        lessonCount: lessonCount,
        quizCount: quizCount,
        videoCount: videoCount
      })]
    }), subCategories && !!subCategories.length && /*#__PURE__*/_jsx(DynamicWidthSection, {
      embeddedSignupRef: embeddedSignupRef,
      children: /*#__PURE__*/_jsx(UIList, {
        childClassName: "m-right-2 m-bottom-0 p-x-0 p-y-0",
        className: "m-bottom-10",
        inline: true,
        children: subCategories.map(subCategory => /*#__PURE__*/_jsx(UITag, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `academyPublic.categories.${subCategory}`
          })
        }, subCategory))
      })
    }), description && /*#__PURE__*/_jsxs(DynamicWidthSection, {
      className: "m-bottom-10",
      embeddedSignupRef: embeddedSignupRef,
      children: [/*#__PURE__*/_jsx(H5, {
        children: contentType === 'LESSON' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.contentLandingPage.secondaryDetails.lessonDescription"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.contentLandingPage.secondaryDetails.courseDescription"
        })
      }), description]
    })]
  });
};
export default PublicLandingPageSecondaryDetails;